<script>
import appConfig from "@/app.config";
import user from "@/mixins/user";

export default {
  page: {
    title: "NotFound",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins:[user],
  methods: {
    handelBack() {
      let rootScreenUrl = this.getRootScreenUrl();
      return this.$router.push({ path: rootScreenUrl });;
    },
    handleLogout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<template>
  <div class="text-center min-vh-100 d-flex flex-column align-items-center justify-content-center gap-3">
    <div class="p-5 border-1 border-success border">
      <span class="text-success h1">お探しのページは見つかりませんでした。</span>
    </div>
    <div class="text-center">
      <b-button
        variant="primary"
        class="me-2"
        @click="handleLogout"
      >
        {{ this.$lang.button.logout }}
      </b-button>
      <b-button
        variant="primary"
        @click="handelBack"
      >
        <i class='far fa-arrow-alt-circle-left'></i>
        {{ this.$lang.button.back }}
      </b-button>
    </div>
  </div>
</template>
